// Next Diamonds — Stone-facts mirror (PDP)
// Reads the per-product stone facts from a JSON script tag emitted by
// pdp-stone-mirror.liquid, then:
//   (a) Populates window.NDStoneFacts so the global cart-stone-mirror
//       interceptor (sitewide) can inject Shape/Color/Clarity on ANY
//       /cart/add.js call — including Quick Buy modals where this script
//       doesn't get a chance to run.
//   (b) Injects them as hidden line-item properties on every cart-add
//       form CURRENTLY in the DOM (covers the classic PDP path).
//
// Why both: belt-and-suspenders. (b) handles the case where Symmetry's
// FormData snapshot of inputs is what's POSTed. (a) handles every other
// case — Quick Buy, third-party Add to Cart buttons, AJAX from sections
// rendered after our script ran.

(function () {
  'use strict';

  // Walk every <script data-nd-stone-facts> in the document (there may be
  // multiple if the page renders several products' info — collection page
  // with Quick Buy cards, recommended products on PDP, etc.) and register
  // each into the global lookup keyed by variant ID and product handle.
  function harvestFacts() {
    var nodes = document.querySelectorAll('script[data-nd-stone-facts]');
    var registered = [];
    nodes.forEach(function (node) {
      var data;
      try {
        data = JSON.parse((node.textContent || '').trim() || '{}');
      } catch (e) { return; }
      if (!data) return;
      var facts = {
        _Shape: data.Shape || '',
        _Color: data.Color || '',
        _Clarity: data.Clarity || '',
        _Cut: data.Cut || ''
      };
      window.NDStoneFacts = window.NDStoneFacts || {};
      if (data.productHandle) {
        window.NDStoneFacts['handle:' + data.productHandle] = facts;
      }
      if (data.productId) {
        window.NDStoneFacts['product:' + data.productId] = facts;
      }
      if (Array.isArray(data.variantIds)) {
        data.variantIds.forEach(function (vid) {
          window.NDStoneFacts['variant:' + vid] = facts;
        });
      }
      registered.push({ node: node, facts: facts });
    });
    return registered;
  }

  function getProductForms() {
    return document.querySelectorAll(
      'form[action*="/cart/add"], product-form form, form[action$="/cart/add"]'
    );
  }

  function ensureProp(form, key, value) {
    if (!value) return;
    var existing = form.querySelector('input[name="properties[' + key + ']"]');
    if (existing) { existing.value = value; return; }
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + key + ']';
    input.value = value;
    form.appendChild(input);
  }

  // Find the first registered fact-set whose script tag is in (or contains)
  // this form's section. Most product pages have only one set; this just
  // protects against accidental cross-product injection on multi-product
  // templates.
  function pickFactsForForm(form, registered) {
    if (!registered.length) return null;
    // If only one fact-set on the page, it definitionally belongs to this PDP.
    if (registered.length === 1) return registered[0].facts;
    var section = form.closest('section, .shopify-section, .product, product-form');
    if (section) {
      for (var i = 0; i < registered.length; i++) {
        if (section.contains(registered[i].node)) return registered[i].facts;
      }
    }
    return registered[0].facts;
  }

  function inject() {
    var registered = harvestFacts();
    if (!registered.length) return;
    getProductForms().forEach(function (form) {
      var facts = pickFactsForForm(form, registered);
      if (!facts) return;
      Object.keys(facts).forEach(function (key) {
        ensureProp(form, key, facts[key]);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  // Re-run in case Symmetry mounts product forms asynchronously
  setTimeout(inject, 500);
  setTimeout(inject, 1500);
})();
